import { ArrowUpIcon } from '@heroicons/react/24/outline';
import { Button, formatPrice } from '@retainerclub/common';
import { useLocale } from '@retainerclub/hooks';
import PropTypes from 'prop-types';

function CurrentSubscriptionUpgrade({ upgrades, handleUpgrade }) {
  const { locale } = useLocale();

  return upgrades.length > 0 ? (
    <div>
      <h4 className="font-semibold text-gray-900 text-md">Upgrade Options</h4>
      <p className="mb-3 text-gray-600 text-sm">
        More retainers, bigger savings.
      </p>
      <div className="space-y-3">
        {upgrades.map((tier) => (
          <div
            key={tier.id}
            className="flex items-center justify-between rounded-lg border border-rcprimary-600 bg-rcprimary-50 p-4"
          >
            <div className="flex items-center space-x-3">
              <ArrowUpIcon className="h-5 w-5 text-green-600" />
              <div>
                <h5 className="font-medium text-rcprimary-700">
                  {tier.product.name}
                </h5>
                <p className="text-2xl text-gray-600">
                  <span className="font-bold text-rcprimary-700">
                    {formatPrice(
                      tier.overPrice ? tier.price : tier.product.price,
                      locale,
                    )}{' '}
                  </span>{' '}
                  <span className="text-gray-600 text-sm">/ year</span>
                </p>

                <ul className="mt-1 ml-2 list-inside list-disc text-gray-500 text-xs">
                  {tier.product.productFeatures.slice(0, 4).map((feature) => (
                    <li key={feature.id}>{feature.text}</li>
                  ))}
                </ul>
              </div>
            </div>
            <Button
              name="Upgrade"
              size="sm"
              color="green"
              rounded
              onClick={() => handleUpgrade(tier)}
            />
          </div>
        ))}
      </div>
    </div>
  ) : null;
}

CurrentSubscriptionUpgrade.propTypes = {
  upgrades: PropTypes.array.isRequired,
  handleUpgrade: PropTypes.func.isRequired,
};

export default CurrentSubscriptionUpgrade;
